"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _RangeFilter = _interopRequireDefault(require("../RangeFilter"));
var _utils = require("../../../utils");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var payerContractListConfig = function payerContractListConfig(dataSource, credentialedCliniciansList, viewClinicianList, editContract, viewClinicianContracts) {
  var handleMatchClinicianClick = function handleMatchClinicianClick(list) {
    return function (e) {
      e.stopPropagation();
      viewClinicianList(list);
    };
  };
  var getAllCliniciansForPayerContracts = function getAllCliniciansForPayerContracts(payerContract) {
    var clinicianPayerContracts = payerContract.clinicianPayerContracts,
      appliesToAllCredentialedClinicians = payerContract.appliesToAllCredentialedClinicians;
    var cliniciansWithPayerContracts = (0, _lodash.map)(clinicianPayerContracts, function (cpc) {
      return _objectSpread(_objectSpread({}, cpc.clinician), {}, {
        contractStatus: cpc.status
      });
    });
    return appliesToAllCredentialedClinicians ? (0, _lodash.uniqBy)([].concat(_toConsumableArray(cliniciansWithPayerContracts), _toConsumableArray(credentialedCliniciansList)), 'email') : cliniciansWithPayerContracts;
  };
  var renderClinicianButton = function renderClinicianButton(_, record) {
    return /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "groups-menu",
      className: "cursor-pointer mt-[12px] text-green1-55",
      onClick: handleMatchClinicianClick(getAllCliniciansForPayerContracts(record))
    });
  };
  var renderClinicianContractsButton = function renderClinicianContractsButton(_, record) {
    return /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "info",
      className: "cursor-pointer mt-[12px] text-green1-55",
      onClick: function onClick() {
        return viewClinicianContracts(record);
      }
    });
  };
  var renderEditButton = function renderEditButton(_, record) {
    return /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "edit-pencil",
      className: "cursor-pointer mt-[6px text-green1-55",
      onClick: function onClick() {
        return editContract(record);
      }
    });
  };
  var renderCliniciansCount = function renderCliniciansCount(_, record) {
    return getAllCliniciansForPayerContracts(record).length;
  };
  var columns = [{
    title: 'Payer Name',
    dataIndex: 'payer.payerName',
    key: 'payer.payerName',
    sorter: (0, _utils.stringSorter)('payer.payerName', true),
    width: 150
  }, {
    title: 'Payer Id',
    dataIndex: 'payer.payerId',
    key: 'payer.payerId',
    sorter: (0, _utils.digitSorter)('payer.payerId', true),
    width: 150
  }, {
    title: 'Payer CPID',
    dataIndex: 'payer.cpid',
    key: 'payer.cpid',
    sorter: (0, _utils.digitSorter)('payer.cpid', true),
    width: 150
  }, {
    title: 'Clinician Count',
    key: 'clinicianCount',
    sorter: (0, _utils.digitSorter)(function (record) {
      return getAllCliniciansForPayerContracts(record).length;
    }),
    width: 150,
    render: renderCliniciansCount
  }, {
    title: 'View Clinicians',
    dataIndex: 'clinicianPayerContracts',
    key: 'clinicianPayerContractsView',
    sorter: false,
    width: 100,
    render: renderClinicianButton
  }, {
    title: 'View Clinician Contracts',
    dataIndex: 'clinicianPayerContracts',
    key: 'clinicianContractsView',
    sorter: false,
    width: 100,
    render: renderClinicianContractsButton
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (0, _utils.stringSorter)('status'),
    width: 150
  }, {
    title: 'Geography',
    dataIndex: 'geography',
    key: 'geography',
    sorter: (0, _utils.stringSorter)('geography'),
    width: 100
  }, {
    title: 'Effective Date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('effectiveDate'),
    render: function render(id, record) {
      return (0, _utils.formatDate)(record.effectiveDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('effectiveDate'),
    width: 150
  }, {
    title: 'Expiration Date',
    dataIndex: 'expirationDate',
    key: 'expirationDate',
    filterDropdown: function filterDropdown(props) {
      return /*#__PURE__*/_react.default.createElement(_RangeFilter.default, props);
    },
    onFilter: (0, _utils.dateRangeFilter)('expirationDate'),
    render: function render(_, record) {
      return (0, _utils.formatDate)(record.expirationDate, {
        utc: true
      });
    },
    sorter: (0, _utils.timeSorter)('expirationDate'),
    width: 150
  }, {
    title: 'Edit Contract',
    dataIndex: 'clinicianPayerContracts',
    key: 'clinicianPayerContractsEdit',
    sorter: false,
    width: 100,
    render: renderEditButton
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = payerContractListConfig;
exports.default = _default;